<template>
  <div class="button-section-container">
    <div class="button-section">
      <SsoButton
        buttonText="Log in with Email"
        imageUrl="email_icon.svg"
        @ssoButtonClicked="handleEmailSignIn"
      ></SsoButton>
    </div>

    <div v-if="showContent" class="content-section">
      <ValidationObserver ref="observer">
        <v-form @submit.prevent="submit">
          <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
          <ValidationProvider
            :id="whitelabel.authentication.login.fieldName"
            v-slot="{ errors }"
            :name="whitelabel.authentication.login.fieldName"
            :rules="whitelabel.authentication.login.validation"
          >
            <TextField
              v-model="uniqueIdentifier"
              :label="whitelabel.authentication.login.fieldTitle"
              :name="whitelabel.authentication.login.fieldName"
              :errors="errors"
            />
          </ValidationProvider>
          <ValidationProvider
            id="password"
            v-slot="{ errors }"
            name="password"
            rules="required"
          >
            <TextField
              v-model="password"
              :label="'Password'"
              :name="'password'"
              :errors="errors"
              :type="'password'"
            />
          </ValidationProvider>
          <v-row no-gutters>
            <v-col cols="12">
              <a @click="forgotPassword" class="forgot-password"
                >Forgot Password?</a
              >
            </v-col>
          </v-row>

          <div class="signin-button">
            <GradientButton
              type="submit"
              @gradientButtonClicked="submitClicked"
              :title="'Log In'"
            />
          </div>
        </v-form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
  import SsoButton from '../guest/SsoButton.vue';
  import loginService from '../../services/LoginService';

  export default {
    name: 'SignInWithEmail',
    props: {},
    components: {
      SsoButton,
    },
    methods: {
      submit() {
        this.$refs.observer.validate().then(valid => {
          if (valid) {
            this.buttonLoading = true;
            this.login();
          } else {
            const errors = this.$refs.observer.ctx.errors;
            document
              .getElementById(
                Object.keys(errors).find(field => errors[field].length)
              )
              .scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        });
      },
      onError(error) {
        this.$emit('onError', error);
      },
      login() {
        const uniqueIdentifier = this.uniqueIdentifier;
        const password = this.password;
        loginService
          .login(
            this.uniqueIdentifier,
            this.password,
            this.$apollo,
            this.$store
          )
          .then(result => {
            if (result.message?.includes('GraphQL error')) {
              throw result;
            }
            const login = result.data.login;
            const accessToken = login.accessToken;
            const refreshToken = login.refreshToken;
            const testatorId = login.testatorId;
            const userId = login.userId;
            const willCountry = login.willCountry;
            const companyId = login.companyId;

            this.$store.dispatch('login', {
              accessToken,
              refreshToken,
              testatorId,
              userId,
              willCountry,
              companyId,
            });
            loginService.setSentryUser(userId);
            loginService.redirectToNext(this.$router, this.$store);
          })
          .catch(error => {
            this.onError(error);
          });
      },
      forgotPassword() {
        this.$emit('forgotPassword');
      },
      handleEmailSignIn() {
        this.showContent = !this.showContent;
        this.$emit('onError', null);
        dataLayer.push({
          event: 'loginwithemailbtn',
          omuserid: 'systemuserid',
        });
      },
      submitClicked() {
        // Do Nothing as it needs to submit
      },
    },
    data() {
      return {
        showContent: false,
        uniqueIdentifier: this.prepopulatedEmail,
        password: null,
        errorMessage: null,
        showPassword: false,
        buttonLoading: false,
      };
    },
  };
</script>

<style lang="scss" scoped>
  .button-section-container {
    width: 100%;

    .button-section {
      margin-bottom: 24px;
      width: 100%;
    }
    .content-section {
      width: 100%;
      .signin-button {
        margin-top: 52px;
      }
      a {
        font-size: 12px;
        font-weight: 500;
        line-height: 18px;
        text-align: left;
        color: #282828;
      }

      .forgot-password {
        text-decoration: underline;
      }
    }
  }
</style>
